import React, { Suspense } from 'react'

export default function SuspenseRoute({
  children,
}: {
  children: React.ReactNode
}) {
  return <Suspense fallback>{children}</Suspense>
}
